// packages/components/src/slot-fill/context.ts
import { observableMap } from "@wordpress/compose";
import { createContext } from "@wordpress/element";
var initialValue = {
  slots: observableMap(),
  fills: observableMap(),
  registerSlot: () => {
  },
  unregisterSlot: () => {
  },
  registerFill: () => {
  },
  unregisterFill: () => {
  },
  updateFill: () => {
  }
};
var SlotFillContext = createContext(initialValue);
SlotFillContext.displayName = "SlotFillContext";
var context_default = SlotFillContext;
export {
  SlotFillContext,
  context_default as default
};
//# sourceMappingURL=context.mjs.map
